import {Col, Container, Form, Row, Button} from "react-bootstrap";
import React, {useState} from "react";

import CarListForm from "./CarsListForm";

import {SeasonModel, SignInUserToASeasonModel} from "../../../features/season/seasonTypes";

type Props = {
    season?: SeasonModel,
    setSelectedCarId: (id: number | 0) => void,
    selectedCarId: number | 0,
    onSubmit: (data:SignInUserToASeasonModel) => void;
}

const SignInForm = ({season, selectedCarId = 0 , setSelectedCarId ,onSubmit}: Props) => {
    const [isChecked, setIsChecked] = useState(false);
    const [name, setName] = useState('');
    const [number, setNumber] = useState(0);
    const [team, setTeam] = useState('');
    const [acceptCheckbox, setAcceptCheckbox] = useState(false);
    const handleNumChange = (event: any) => {
        const limit = 3;
        setNumber(event.target.value.slice(0, limit));
    };

if(!season){
    return <></>
}
    const handleSubmit = (event: any) => {
        event.preventDefault();
        onSubmit({
            car: selectedCarId,
            accept_checkbox: acceptCheckbox,
            name: name,
            number: number,
            team: team
        });
    };
    return (
        <Form  onSubmit={event => {
            handleSubmit(event)
        }}>
            <Container>
                <Row>
                    <Col xs={12} md={8}>
                        <Form.Group controlId="userName">
                            <Form.Label>Driver name</Form.Label>
                            <Form.Control type="text"
                                          value={name} onChange={(event) => setName(event.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                        <Form.Group controlId="carNumber">
                            <Form.Label>Car Number</Form.Label>
                            <Form.Control type="number"
                                          placeholder="First avaible"
                                          value={number} onChange={handleNumChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Form.Group controlId="cars">
                <Row>
                    <Form.Label>Car:</Form.Label>
                    <CarListForm season={season} selectedCarId={selectedCarId} setSelectedCarId={setSelectedCarId}/>

                </Row>
                </Form.Group>
                </Container>
            <Form.Group controlId="team_checkbox" className="p-1 ">
                <Form.Check type="checkbox" label="Join or create team" onChange={() => setIsChecked((prev) => !prev)}/>
            </Form.Group>
            <Form.Group controlId="team" className={`p-1`}>
                <Form.Label>
                    Team Name:
                </Form.Label>
                <Form.Control type="text"
                              placeholder=" "
                              disabled={!isChecked}
                              value={team} onChange={(event) => setTeam(event.target.value)}
                />
            </Form.Group>
            <Form.Group controlId="accept_checkbox" className={`p-1`}>
                <Form.Check type="checkbox"
                            label="accept Terms"
                            checked={acceptCheckbox} onChange={() => setAcceptCheckbox((prev) => !prev)}
                />

            </Form.Group>
            <Button type="submit">Sign Up</Button>
        </Form>
    );
};
export default SignInForm;